import { useEffect , useState } from "react";
import stylesHalil from "./Home.module.css"; // ✅ CSS Module Import Edildi
import ThemeToggle from "./ThemeToggle";
import { blogPosts } from "../data/blogData";
import BlogCard from "../components/BlogCard";

const Home = () => {
    const [message, setMessage] = useState("Loadings....");
    const [clicked, setClicked] = useState(false);
    
    useEffect(()=> { // component on complate
        fetch("http://localhost:5000/api/health") // json formatına çevir
        .then((res) => res.json()) // json formatına çevir
        .then((data)=> setMessage(data.message)) // Gelen mesajı satete'e kaydet
        .catch(()=> setMessage("Cannot fount API!"));
    },[])

    return (
        <div className={stylesHalil.container}>   
            
            <h1>Home Page</h1>
            <p className={stylesHalil.title}>Backend Message: {message}</p>
            <button
                onClick={()=> setClicked(true)}
                className={stylesHalil.button}
            >
                Refresh Message
            </button>
            {clicked && <p style={{color:"green"}}>Message Refreshed</p>}
            <div>
      <ThemeToggle />
      <h1>Hoş Geldiniz!</h1>
      <p>Bu sayfa beyaz yazılarla veya siyah yazılarla çalışabilir.</p>
    </div>

    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Blog Yazıları</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {blogPosts.map((post) => (
          <BlogCard key={post.id} id={post.id} title={post.title} date={post.date} />
        ))}
      </div>
    </div>
        </div>

        
        
    )
};
export default Home;